function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
export var ButtonIcon = function(param) {
    var icon = param.icon, iconStyle = param.iconStyle, iconWrapperStyle = param.iconWrapperStyle, hasChildren = param.hasChildren, isRtl = param.isRtl, reverseSpacing = param.reverseSpacing;
    var IconGlyph = icon;
    return _jsx("span", {
        css: getIconContainerStyle(iconWrapperStyle, hasChildren, isRtl, reverseSpacing),
        children: _jsx(IconGlyph, _objectSpread({}, iconStyle))
    });
};
function getIconContainerStyle(style, hasChildren, isRtl) {
    var reverseSpacing = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var key = isRtl ? 'marginLeft' : 'marginRight';
    if (reverseSpacing) key = isRtl ? 'marginRight' : 'marginLeft';
    return _objectSpread({
        margin: 0,
        display: 'flex',
        alignItems: 'center'
    }, hasChildren ? _defineProperty({}, key, 8) : {}, style);
}
export default ButtonIcon;
